export interface DocumentIdentity extends Record<string, unknown> {
  document_id: string;
  document_title: string;
}

export function nonEmptyDocumentString(value: unknown): string | undefined {
  return typeof value === "string" && value.trim().length > 0
    ? value
    : undefined;
}

export function readDocumentIdentity(
  value: unknown,
): DocumentIdentity | undefined {
  if (!value || typeof value !== "object") return undefined;

  const record = value as Record<string, unknown>;
  const documentId = nonEmptyDocumentString(record.document_id);
  const documentTitle = nonEmptyDocumentString(record.document_title);
  return documentId && documentTitle
    ? { document_id: documentId, document_title: documentTitle }
    : undefined;
}
